import { helpers } from './helpers';

export const dpjFaq = {
    init: () => {
        console.debug("dpj-faq.js: init");

        // on show chat block on contact and faq page if its active. 
        // Chat is opened with a few seconds delay so need to use a timeout
        setTimeout(function () {
            if ($("#dpj_widget").html().trim() != "") {
                $(".contact-form-item-chat").css("display", "grid");
            }
        }, 3000);

        // If user is on FAQ page
        if ($('.dpjfaq_wrap_QA').length) {

            // Display or hide question in FAQ
            $(document).ready(function () {
                $(".dpjfaq_wrap_QA").click(function () {
                    if ($(this).find(".dpjfaq_answer").css("display") == "none") {
                        $(this).find(".dpjfaq_answer").html($(this).find(".dpjfaq_answer").html().replace(/&lt;/g, '<').replace(/&gt;/g, '>'));
                        $(this).find(".dpjfaq_answer").slideDown("400");
                        $(this).find(".dpjfaq_question_arrow").css("transform", "rotate(90deg) rotateY(180deg)");
                    } else {
                        $(this).find(".dpjfaq_answer").slideUp("400");
                        $(this).find(".dpjfaq_question_arrow").css("transform", "rotate(90deg) rotateY(0deg)");
                    }
                });
            });

            // Scroll user to the FAQ-category they clicked 
            $(".scroll_to_category").click(function() {
                var classList = $(this).attr('class').split(/\s+/);
                var scroll_to_item = "";
                $.each(classList, function(index, item) {
                    if (item.includes("scroll_to_category_")) {
                        scroll_to_item = item.split("_")[3];
                    }
                });
                helpers.scrollWindow("#category_" + scroll_to_item);
            });
        }
    },

}